"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackDrop = exports.BalanceText = exports.ModalContent = exports.Wrapper = exports.Container = exports.StyledText = exports.Title = void 0;
const native_1 = __importDefault(require("styled-components/native"));
const atoms_1 = require("../../atoms");
exports.Title = native_1.default(atoms_1.PText) `
  text-align: center;
`;
exports.StyledText = native_1.default(atoms_1.PText) `
  text-align: left;
  font-size: 13px;
`;
exports.Container = native_1.default.View `
  padding: 32px;
  width: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;
exports.Wrapper = native_1.default.View `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  z-index: 999;
`;
exports.ModalContent = native_1.default.View `
  width: 100%;
  background-color: #fff;
  top: 0px;
  left: 0;
  right 0;
  position: absolute;
`;
exports.BalanceText = native_1.default.Text `
  text-align: center;
  color: ${({ theme }) => theme.bpCore.colors.error};
  font-size: ${({ theme }) => theme.bpCore.typography.heading3.fontSize};
`;
exports.BackDrop = native_1.default.View `
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: -1;
  background-color: rgba(17, 17, 17, 0.4);
`;
